import "./App.css";
import Home from "./components/Home";
import Register from "./components/Register";
import NavBar from "./components/NavBar";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import RegSuccess from "./components/RegSuccess";
import AdminPanel from './components/AdminPanel';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { HashLoader } from "react-spinners";
import GlobalContext from "./context/GlobalContext";
import * as api from "./api/index";

function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <div className="App">
      <Router>
        <NavBar />
        <div className="bodyCenter">
          {loading ? (
            <HashLoader
              size={150}
              color={"#2A25EC"}
              loading={loading}
            ></HashLoader>
          ) : (
            <Routes>
              <Route path="/" element={<Home />}></Route>
              <Route path="/account/login" element={<Login />}></Route>
              <Route path="/account/register" element={<Register />}></Route>
              <Route
                path="/account/forgotpassword"
                element={<ForgotPassword />}
              ></Route>
              <Route
                path="/account/registrationSuccess"
                element={<RegSuccess />}
              ></Route>
              <Route path="/account/adminPanel" element={<AdminPanel />}></Route>
            </Routes>
          )}
        </div>
      </Router>
    </div>
  );
}

export default App;
